/** API route map: URLS.Controller.ClientBenefitsGroup */
export const ClientBenefitsGroup = {
      Name: 'ClientBenefitsGroup/',
      GetAllGroups: 'getall-groups',
      GetAllPlans: 'getall-plans',
      Add: 'add',
      AddBenefitsPlans: 'add-benefits-plans',
      AddToLibraryPlans: 'add-to-library-plans',
      Delete: 'delete',
      DeleteGroupPlan: 'delete-plangroup',
      Update: 'update',
      UpdateGroupStatus: 'update-clientgroupStatus',
      GetClientBenefits: 'get-clientbenefits',
      GetAllBenefits: 'get-allbenefits',
      SearchBenefitsGroup: 'search-benefits-group',
      GetClientBenefitsGroups: 'get-clientbenefits-groups',
      GetClientBenefitsGroupDetails: 'get-all-client-benefits-group-details',
      getClientBenefitsGroupName: 'get-client-benefit-group-name',
      getClientBenefitsGroupNameEnrollment: 'get-client-benefit-group-name-enrollment',
      getClientBenefitsGroupNameEnrollmentEmployee:
        'get-client-benefit-group-name-enrollment-employee',
      getClientBenefitsGroupPlans: 'get-client-benefit-group-plans',
      getClientBenefitsGroupPlansEnrollment: 'get-client-benefit-group-plans-enrollment',
      getClientBenefitsGroupPlansEnrollmentEmployee:
        'get-client-benefit-group-plans-enrollment-employee',
      GetClientGroupBenefitPlan: 'get-client-group-benefit-plan',
      GetAllBenefitPlanLibrary: 'get-library-details',
      GetAllBenefitPlanLibraries: 'get-all-benefit-plan-libraries',
      DeleteBenefitPlanLibrary: 'delete-benefit-plan-library',
};
